import { BriefcaseArrowLeftRightIcon } from './BriefcaseArrowLeftRightIcon';

/**
 * author: Michael Irigoyen
 * id 6DB6F4EA-1ACC-481A-8EC5-3D9FA65408BE
 * name briefcase-arrow-left-right
 * version: 6.8.96
 * url https://raw.githubusercontent.com/Templarian/MaterialDesign/master/svg/briefcase-arrow-left-right.svg
 * tags
 */
export const BriefcaseSwapIcon = BriefcaseArrowLeftRightIcon;
export default BriefcaseSwapIcon